import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./AboutUs.module.css";

type Props = {};

const AboutUs: React.FC<Props> = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.AboutUs} id="about" data-section="about">
      <div className={styles.Backdrop} />
      <div className={styles.heading}>
        <span>{t("aboutUs.title")}</span>
        <img src="/about-us/logo.png" alt="Logo" fetchPriority="high" />
      </div>
      <div className={styles.Content}>
        <div className={styles.photo}>
          <img src="/about-us/paola.jpg" alt="Paola Alterio" fetchPriority="high" />
        </div>
        <div className={styles.bio}>
          <span className={styles.name}>Paola Alterio</span>
          <span className={styles.role}>{t("aboutUs.paola.subTitle")}</span>
          <div className={styles.text}>
            {(t("aboutUs.paola.text", { returnObjects: true }) as string[]).map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
